core.component('menuComponent', {
    templateUrl: 'components/menu/menu.html',
    controller: 'menuComponentController',
    bindings: { hideNav: '<', menuItems:'<', simpleMode: '=' }
});

core.controller('menuComponentController', ['$state', '$transitions', 'coreLanguage', '$document', '$scope', 'coreFb', function($state, $transitions, $text, $document, $scope, $fb) {
    const $ctrl = this;

    $ctrl.accountLabel = $text.menu.account;
    $ctrl.showDrawer = false;

    $ctrl.isActive = (route) => {
        return $state.current.name.startsWith(route);
    }

    $ctrl.toggleDrawer = () => {
        $ctrl.showDrawer = !$ctrl.showDrawer;
    }

    $ctrl.logout=()=>{
        $fb.auth.logout().then(() => {
            $state.go('login');
        });
    };

    $transitions.onFinish({}, () => {
        $ctrl.showDrawer = false;
    });

    const handleClickOutside = (event) => {
        const sidebarElem = document.querySelector('.pc-sidebar');
        const menuToggle = document.getElementById('menu-toggle');

        if ((sidebarElem && menuToggle) && (!sidebarElem.contains(event.target) && !menuToggle.contains(event.target))) {
            if($ctrl.showDrawer){
                $ctrl.showDrawer = false;
                $scope.$apply();
            }
        }
    };

    $document.on('click', handleClickOutside);

    $ctrl.$onDestroy = () => {
        $document.off('click', handleClickOutside);
    };

    _getUser=(idUsuario)=>{
        $ctrl.usuario = {};

        $fb.db.get(`/cad_usuarios/${idUsuario}`).then(userDoc=>{
            $ctrl.usuario = {
                nome: userDoc.data.nome,
                fotoUrl: userDoc.data.fotoUrl,
                setor: 'Administrador'
            };
        });

        
    };

    $ctrl.$onInit=()=>{
        let idUsuario = $fb.auth.getIdToken().claims.idUsuario;

        _getUser(idUsuario);
    };

}]);